import { faCircleUser, faClipboard, faFileInvoiceDollar, faLayerGroup, faList, faMoneyCheckDollar, faOilWell, faTablet, faToolbox, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { SVGIcon } from "@progress/kendo-angular-icons";

export function convertFaIconToKendoIcon(faIcon: IconDefinition, pathParams: string = ''): SVGIcon {
  return {
    name: faIcon.iconName,
    content: `<path ${pathParams} d="${faIcon.icon[4]}"/>`,
    viewBox: `0 0 ${faIcon.icon[0]} ${faIcon.icon[1]}`
  };
}

export const faIcons = {
  clipboard: convertFaIconToKendoIcon(faClipboard),
  invoice: convertFaIconToKendoIcon(faFileInvoiceDollar),
  layers: convertFaIconToKendoIcon(faLayerGroup),
  list: convertFaIconToKendoIcon(faList),
  moneyCheck: convertFaIconToKendoIcon(faMoneyCheckDollar),
  oilWell: convertFaIconToKendoIcon(faOilWell),
  tablet: convertFaIconToKendoIcon(faTablet),
  toolbox: convertFaIconToKendoIcon(faToolbox),
  userCircle: convertFaIconToKendoIcon(faCircleUser),
} satisfies Record<string, SVGIcon>;